import localforage from 'localforage';
import StoreBase from './lib.r3/StoreBase'
import Sys from './lib.r2/utils/SystemUtils';
import DateFormat from './lib.r2/utils/DateFormat';


// ---------------------------------------------------------------------------- getLabel
global.getLabel = (val, alt='') => {
	if (!val || !global.labels) return alt;
	let src = typeof val === 'string'? global.labels[val] : val;
	return src? (src[global.lang || 'en'] || Object.values(src)[0]) :
		alt || (typeof val === 'string'? val : '')
}


//============================================================================= Store
class Store extends StoreBase{
	headers = {
		'Accept'		: 'application/json',
		'Content-Type'	: 'application/json',
	}
	action = () => {}		//placeholder

	system = Sys.getSystem()

	info = {
		'version' 	: null,
		'server'	: null,
		'last'		: {label: 'last session'},
		'start' 	: {label:'session started'},
		'user'	: null,
		'mandate'	: null,
		'warehouse'	: null,
		'bundles'	: null,
		'bundle'	: {label:'selected bundle'},
		// 'setup' : {label:'setup from'}

		'agent'		: this.system.agent,
		'browser'	: this.system.browser,
		'device'	: this.system.device,
		'environment' : this.system.environment,
		'location' 	: this.system.location,
		'os' 		: this.system.os,
		'runtime'	: this.system.runtime,
		'react.version'	: {label:'react version', value:this.system.version.react},
	}

	settings = {
		onChange : async e => {
			console.log('changed:', this.settings.source)
			await this.cache.setItem('settings', this.settings.source)
		},

		onSelect : e => {	//select a button
			// console.log('selected', e, this.settings.source)
			// this.settings.source.check2._state[1](false)
			// if (e === 'test-button') this.onLogTest()
			// this.settings.nodes.check2._set(e => !e)
		},

		source : {
			// test	: {type:'button', name:'test-button'},
			cam		: {label:'init camera on startup', type:'check', selected:true},
			// test1	: {type:'button', name:'test-button'},
			// value	: false,
		}
	}


	// ------------------------------------------------------------------------ init
	async init(){
		console.info('system:', this.system)
		console.info('navigator:', navigator)

		let config = await(await fetch('./config.json')).json()

		let url = (window.location.hostname.startsWith('localhost') || window.location.host.startsWith('192'))?
			config.api.server:
			(window.location.protocol + '//' + window.location.host + '/');

		//replace config api settings
		config.api = {
			server		: url,
			url 		: url + config.api.url,
			uploads		: url + config.api.uploads
		}

		// ---prepared for next release:
		// let sub = config.version.split('.').splice(2).join('.')
		let versionInfo = 'Build: ' + config.version + ' | ' + config.release

		this.set({
			config,
			isOnline	: false,
			isLogedIn	: false,
			isLoaded	: false,
			versionInfo,
		})

		await super.init(config)		//create cache

		let settings = await this.cache.getItem('settings')
		if (settings) this.settings.source = settings

		let last = this.get().lastSession
		last = last? DateFormat(last) : null
		let start = DateFormat(this.get().sessionStart)
		this.setInfo({version:versionInfo, server:config.api.server, last, start})

		this.cache.setItem('version', config.version)

		this.mediaCache = localforage.createInstance({
			name: config.name,
			storeName: 'media-cache'
		})

		if (this.config.onlineCheck?.enabled) this.startOnlineCheck()
	}


	// ------------------------------------------------------------------------ initCamera
	async initCamera(){
		if (global.cameraInit && !global.cameraIsInit){ //---first user click: initialize the camera'
			console.log('---camera init ...')
			global.cameraIsInit = true
			await global.cameraInit?.()
		}
	}

	// ------------------------------------------------------------------------ stopCamera
	async stopCamera(){
		if (!store.settings.source.cam.selected){
			console.log('---camera closed!')
			global.cameraIsInit = false
			this._cameraStop?.()
		}
	}


	// ------------------------------------------------------------------------ setInfo
	setInfo(id, value){
		if (typeof id === 'object'){
			Object.entries(id).forEach(e => this.setInfo(e[0], e[1]))
		}else{
			if (this.info[id] === undefined){
				this.info[id] = {label:id, value}
			}
			else {
				if (this.info[id] === null) this.info[id] = {label:id}
				this.info[id].value = value
			}
		}
	}


	// ------------------------------------------------------------------------ fetch
	stopSession(){
		console.info('stop session!')
		this.stopOnlineCheck()
		this.action('logoff')
	}


	// ------------------------------------------------------------------------ fetch
	// fetch for all json endpoint requests
	async fetch(url, options, callback, cache){
		let method = options?.method || 'GET'

		const controller = new AbortController();
		const timeout = setTimeout(() => controller.abort(), this.config.loadingTimeout || 30000);

		let res = await fetch(url, {
			method,
			headers: options?.headers? {...this.headers, ...options.headers} : this.headers,
			body: options?.body || null,
			...options,
			signal: controller.signal

		}).catch(err => null)

		clearTimeout(timeout);

		if (res?.status === 403){
			console.error('session unauthorised!')
			this.action('logoff')
			return null
		}

		if (!res?.ok){
			if (method === 'HEAD'){
				callback?.(false);
				return false;
			}

			if (cache){
				let data = await this.cache.getItem(cache);
				if (data){
					console.log('data from localStore:', data);
					callback?.(data);
					return data;
				}
			}

			callback?.(null)
			return null
		}

		if (method === 'HEAD'){
			callback?.(true);
			return true;
		}

		if (options === 'text'){	//text request
			let text = await res.text()
				.catch(err => {
					// console.error('json error!', err)
					return null
				})

			callback?.(text)
			return text

		}else{		//default json request
			let json = await res.json()
				.catch(err => {
					// console.error('json error!', err)
					return null
				})
	
			if (json && cache){
				// console.log('data to localStore:', cache, json);
				await this.cache.setItem(cache, json);
			}
	
			callback?.(json)
			return json
		}
	}


	// ------------------------------------------------------------------------ setUser
	setUser(user){
		this.user = global.user = user

		this.headers.Authorization = 'Bearer ' + (user._token || '')
		this.checkOnlineState()
	}


	// ------------------------------------------------------------------------ cleanUpBundle
	cleanUpBundle = bundle => {
		if (!bundle) return

		if (bundle.level) bundle.level = bundle.level.toLowerCase()

		if (bundle.child){
			// if (bundle.child_id !== bundle.child.id){
			// 	console.error('wrong child-id!', bundle)
			// }
			// if (bundle.child.parent_id !== bundle.id){
			// 	console.error('wrong parent-id!', bundle)
			// }
			this.cleanUpBundle(bundle.child)
		}

		// ---fixing leading zeros in gtin numbers 
		if (bundle.gtin.startsWith('0')) bundle.gtin = bundle.gtin.replace(/^0+/, '');		//replace all leading 0s
		if (bundle.gtins){
			bundle.gtins.forEach((g, i) => {
				if (g.startsWith('0')) bundle.gtins[i] = g.replace(/^0+/, '');		//replace all leading 0s
			})
		}
		///
	}


	// ------------------------------------------------------------------------ loadWarehouseBundles
	// from select-warehouse
	// e.g. https://knapp-dev.jumptoday.group/bl/public/api/bundles/lite?warehouse_id=8
	//
	loadWarehouseBundles = async (state, wh) => {
		if (!wh?.id) return

		wh._bundles = []

		console.log('load warehouse bundles ...', wh)
		this.setInfo('warehouse', wh.name)

		let url = state.config.api.url + 'bundles/lite?warehouse_id=' + wh.id;
		console.log('load bundles ...', url);

		//load bundles online or from store
		// let bundles = await this.fetch(url, null, null, 'bundles-data-' + wh.id)
		let bundles = await this.fetch(url, null, null)		//loading online

		if (bundles){	//loaded successfully online
			// set timestamp of the current loaded warehouse bundles
			let now = Date.now()
			await this.cache.setItem('bundles-data-' + wh.id + '-timestamp', now)
			console.log('bundles data cached:', 'bundles-data-' + wh.id)

			await this.warehouseBundlesLoaded(wh, bundles, state)

		}else{			//loading error
			if (!this.get().isOnline){	//offline
				console.log('load warehouse bundles from cache:', 'bundles-data-' + wh.id)
				let cached = await this.cache.getItem('bundles-data-' + wh.id)	//load from cache
				if (cached){
					console.log('ok')
					await this.warehouseBundlesLoaded(wh, cached, state)
					return
				}
			}
			state.action('message', {
				title: global.getLabel('warehouse_loading_error', 'error on loading warehouse data'),
				buttons: [
					{label: global.getLabel('loading_error_retry', 'retry'), action:'message-close'},
				]
			})
		}
	}


	// ------------------------------------------------------------------------ warehouseBundlesLoaded
	async warehouseBundlesLoaded(wh, bundles, state){
		let time = await this.cache.getItem('bundles-data-' + wh.id + '-timestamp')

		wh._bundles = bundles.filter(b => b.level === 'case' && b.warehouse_id === wh.id);

		//wrong bundles:
		// console.log('wrong bundles:', bundles.filter(b => b.level !== 'case' || b.warehouse_id !== wh.id ))

		// performance test
		if (wh.test) this.createTestWarehouse(wh)

		let items = {}
		wh._bundles.forEach(b => items[b.item_id] = b)		//search for all unique items
		wh._num_items = Object.keys(items).length

		this.setInfo('bundles', 'total:' + bundles.length
			+ ', valid: ' + wh._bundles.length
			+ ', items: ' + wh._num_items
			+ ' (from: ' + DateFormat(time) + ')')
		console.log('bundles:', wh._bundles.length, this.info.bundles)

		wh._bundles.forEach(bundle => {
			this.cleanUpBundle(bundle)

			bundle._search = this.createSearchString(bundle)
			this.parseAttributeImages(bundle)
		})

		state.action('warehouse-bundles-loaded', wh)		//append scan to scan-log
	}


	// ------------------------------------------------------------------------ updateWarehouseBundlesCache
	// update the current cached bundles
	// from parseAndSaveResult
	async updateWarehouseBundlesCache(state){
		let wh = state.warehouse
		if (!wh) return

		console.log('---updateWarehouseBundlesCache:', 'bundles-data-' + wh.id, wh)
		await this.cache.setItem('bundles-data-' + wh.id, wh._bundles);

	}


	// ------------------------------------------------------------------------ parseAttributeImages
	parseAttributeImages(node){
		if (!node) return

		if (node.attributes){
			for(let k in node.attributes){
				if (k.startsWith('image_')){
					if (!node.attributes[k].startsWith('data') && !node.attributes[k].startsWith('http')){
						node.attributes[k] = this.config.api.uploads + node.attributes[k]
					}
				}
			}
		}

		if (node.child) this.parseAttributeImages(node.child)
	}


	// ------------------------------------------------------------------------ copyAttributeImages
	// copy attribute images from source to target
	copyAttributeImages(source, target){
		if (!source?.attributes || !target?.attributes) return

		if (source.attributes && target.attributes){
			for(let k in source.attributes){
				if (k.startsWith('image_')){
					target.attributes[k] = source.attributes[k]
				}
			}
		}

		if (source.child && target.child) this.copyAttributeImages(source.child, target.child)
	}


	// ------------------------------------------------------------------------ createSearchString
	createSearchString(bundle){
		if (!bundle) return

		let search = []

		let child = bundle
		while(child){
			search.push(child.name?.toLowerCase())
			search.push(child.id)
			search.push(child.articleNo)
			search.push(child.comment?.toLowerCase())
			search.push(child.gtin?.toLowerCase())
			if (child.gtins) {
				for (let i = 0; i < child.gtins.length; i++) {
					search.push(child.gtins[i].toLowerCase());
				}
			}	//append all gtins
	
			child = child.child
		}

		search = search.filter(s => s)	//remove empty values
		search = [...new Set(search)]	//remove duplicates
		return search.join(' ')			//create string
	}


	// ------------------------------------------------------------------------ parseSetup
	parsePages(warehouse, setup){
		if (!warehouse?.teachin || !warehouse?._bundles || !setup?.content) return

		console.info('... parsePages:')
		console.info('setup:', setup)
		console.info('warehous:', warehouse)
	
		//---create deep working copy
		let chapters = JSON.parse(JSON.stringify(setup.content.chapters));	//create deep copy

		let _ch = {}					//page lookup list
		chapters.forEach(ch => {
			_ch[ch.name] = ch
			ch._pages = {}
			ch.pages?.forEach(p => {	//chapter pages
				ch._pages[p.name] = p
			})
		})
// this.set({settings:_ch}) ???

		let _chapters = []		//final used chapters

		warehouse.teachin.chapters.forEach(ch => {
			if (ch.name === 'start'){
				let settings = {}
				ch.pages?.forEach(p => {
					settings[p.name] = p.settings
				})
console.log('start settings:', settings)
				this.set({settings})
				
			}

			let ch_ = _ch[ch.name]			//get target chapter from lookup
			// let last		//circular structure issue!

			if (ch_){
				// console.log('c--', ch_.name)
				_chapters.push(ch_)
				ch_.pages = []				//clear original chapter pages

				ch.pages?.forEach(p => {	//get target page from lookup
					let p_ = ch_._pages[p.name]
					if (p_){
						// console.log('\tp--', p.name)
						p_._settings = p.settings
						ch_.pages.push(p_)

						// if (last){			//linked list
						// 	last._next = p_
						// 	p_._prev = last
						// }
						// last = p_
					}else{
						console.error('setup page missing:', p.name)
					}
				})
			}
		})

console.info('result source:', _ch)
console.info('result target:', _chapters)

		setup.content._chapters = _chapters
	}


	// ------------------------------------------------------------------------ createTestWarehouse
	// for performance & stress tests
	// create n test-bundles with 3 gtins each for simulation
	//
	createTestWarehouse	= (wh) => {
		let num = this.config.createTestWarehouse || 1000
		if (num > 1000000) num = 1000000		//max 1 million bundles
		
		console.log('create test warehouse:', num, '...')

		let len = wh._bundles.length
		let bundles = []
		let src, gtin, b
		let base = '10000000'

		for (let i=0; i<num; i++){
			src = JSON.stringify(wh._bundles[i % len])
			gtin = base + String(i*3)
			b = JSON.parse(src)
			b.test = true		//mark test bundle

			b.id = b.item_id = i
			if (b.item) b.item.id = i
			if (b.child) b.child.parent_id = i;		//set child id

			b.gtin = gtin
			b.gtins.push(gtin)
			b.gtins.push(base + String(i*3 + 1))
			b.gtins.push(base + String(i*3 + 2))
			bundles.push(b)
		}

		wh._bundles = bundles
	}


	// ------------------------------------------------------------------------ findGtin
	// find best matched bundle from defined gtin
	findGtinBundle = (bundles, gtin) => {
// ---test gtin
// gtin = 'X0014TC6BY11'
		if (!bundles?.length) return []

		// gtin = gtin.toLowerCase().replace(/^0+/, '');	//replace all leading 0s
		gtin = gtin.replace(/^0+/, '');		//replace all leading 0s

		console.log('search over ' + bundles.length + ' bundles for gtin ' + gtin + ' ...');
		let t = performance.now()

		let bundle = bundles.find(b => b.gtins.find(g => g === gtin));
		if (bundle){
			bundle.gtin = gtin;		//replace gtin as primary gtin
			console.log('exact match found!', bundle)
			return [bundle];		//exact match found!
		}

		// let length = this.config.gtinMatchLength || 10
		// gtin = gtin.substring(0, length)
		// let foundBundles = bundles.filter(b => b.gtins.find(g => g.startsWith(gtin)))

		let minLenght = this.config.gtinMatchLength

		let foundBundles = []
		while(!foundBundles.length && gtin.length > minLenght){
			gtin = gtin.substring(0, gtin.length - 1)
			const currentGtin = gtin; 	// capture current value
			foundBundles = bundles.filter(b => b.gtins.find(g => g.startsWith(currentGtin)))
			console.log('search gtin:', currentGtin, '...', foundBundles.length)
		}

		t = performance.now() - t
		if (foundBundles.length) console.log('matched gtin found:', gtin, foundBundles.length)
		else console.log('no matched gtin found!', gtin)

		console.log('duration:', t, 'ms')

		// return foundBundles.length === 1? foundBundles[0] : [];
		return foundBundles
	}


	// ------------------------------------------------------------------------ getBundleNode
	// first bundle level muste be the case!
	// case | pack | unit
	getBundleNode = (bundle, name) => {
		let node = bundle
		if (node.level === name) return node
		while(node.child){
			node = node.child
			if (node.level === name) return node
		}
		return bundle		//take the root node if no child was found
	}


	// ------------------------------------------------------------------------ parseBundle
	// prepare the selected bundle
	//
	parseBundle = (state) => {
		let bundle = state.bundle;

		console.log('---parseBundle', bundle._new? 'new:' : bundle._clone? 'clone:' : 'found:', bundle);

		let setup = state.setup;
		setup._pages = [];
		setup._numPages = 0;

		// setup._chapters = JSON.parse(JSON.stringify(setup.content.chapters));	//create deep copy
		setup._chapters = JSON.parse(JSON.stringify(setup.content._chapters));		//create deep copy

console.log('   chapters:', setup._chapters)
		// setup._packValid = false;
		// setup._unitValid = false;

		// prepare missing levels
		if (!bundle.child) bundle.child = {level:'pack', gtin:''}
		if (!bundle.child.child) bundle.child.child = {level:'unit', gtin:''}

		let key = 0
		let _node	// = bundle;
		let last		//page reference for linked list 
		// console.log('...productionSystem:', pSystems);

		// let lid = _node.loadcarrier_id;
		setup._chapters.forEach(ch => {
			_node = this.getBundleNode(bundle, ch.name)

			// if (!_node) console.error('pack-child missing!', ch.name)
			if (ch.name === 'case' || ch.name === 'pallet'){

			}else if (ch.name === 'pack'){			//pack-chapter
				setup._pack = _node;
				setup._pack._pageId = setup._numPages;		//page-id of the pack-section

			}else if (ch.name === 'unit'){		//unit-chapter
				setup._unit = _node;
				setup._unit._pageId = setup._numPages;		//page-id if the unit-section

			}else if (ch.name === 'misc'){		//diverse
				// _node = bundle.item		//for custom item attributes

			}else{
				console.error('level missing!', ch.name)
			}

			if (_node && (!_node.attributes || Array.isArray(_node.attributes))) _node.attributes = {};

			ch._ready = false;
			ch._bundle = _node;					//set bundle reference
			// ch._numPages = ch.pages.length;
			ch._firstPage = setup._numPages;
			ch._numPages = 0;
			ch._active = true;

			ch.pages.forEach(p => {
				p._valid = true					//page valid
				p._active = true
				p._chapter = ch					//reference to the chapter of this page
				p._bundle = ch._bundle			//set bundle reference

				if (last){						//linked list
					last._next = p
					p._prev = last
				}
				last = p

				if (p.warehouses){				//page filter for warehouses
					p._valid = p.warehouses.includes(state.warehouse.id)
				}

				if (p._valid && state.isCopy){
					p._valid = p._settings?.enableAfterLikeBundleCopy
				}

				if (p.name.endsWith('custom_attributes')){		//this is a custom-attributes page
					if (!p._settings.enabledAttributes){
						console.error('warning! custom page has no _settings.enabledAttributes:', p)
						p._valid = false
					}
				}

				p._valid && p.sections.forEach(s => {
					s._bundle = _node			//set bundle reference
					s._valid = true				//section valid

					s.components.forEach(com => {
						com._section = ch.name
						com._bundle = _node	//set bundle reference
						com._valid = true

						switch (com.type){
						case 'multiscan':
							com.multiscans?.forEach(table => {
								let tid = table.warehouse_id + '.' + table.id
								if (!state.tables[tid]) state.tables[tid] = table	//new table found
							})

							com.additionalAttributes?.forEach(at => {
								at._valid = at.warehouses.includes(state.warehouse.id)
							})
							break;
						case 'photo-grid':
							com.content.forEach(c => {	//c.attribute = image_iso || image_front
								c._bundle = _node;
								let e = _node?.attributes[c.attribute];
								if (e){
									c._photo = (e.startsWith('data') || e.startsWith('http'))? e : state.config.api.uploads + e;
								}
							});
							break;
						case 'boolean':
							//if chapter = diverse than its a item-attribute
							if (ch.name === 'misc') com._bundle = bundle.item
							break;
						case 'enum':
							//if chapter = diverse than its a item-attribute
							if (ch.name === 'misc') com._bundle = bundle.item
							break;

						case 'stepper':
							var pro = com.property? _node?.[com.property]: com.attribute? _node?.attributes[com.attribute] : null;
							com.value = Number(pro);
							break;

						case 'image-grid':
						case 'icon-grid':
						case 'group':
							var pro = com.property? _node?.[com.property]: com.attribute? _node?.attributes[com.attribute] : null;

							if (com.attribute_id && p._settings.enabledAttributes){		//custom attribute
								com._valid = !!p._settings.enabledAttributes.find(a => a === com.attribute_id)
							}
							com._hasToiletPaper = !!com.content?.find(e => e.label?.en.toLowerCase() === 'toilet paper')

							if (com.attribute_id && p._settings.enabledAttributes){		//custom attribute
								com._valid = !!p._settings.enabledAttributes.find(a => a === com.attribute_id)
							}

							if (com._valid && com.content){
								com.content = com.content.filter(c => !c.warehouses || c.warehouses.includes(state.warehouse.id))
								// com._valid = com.content.length > 0

								com.content.forEach(c => {
									c._section = ch.name
									c._valid = !c.warehouses || c.warehouses.includes(state.warehouse.id);
									if (!c._valid) return;

									if (c.attribute) pro = _node?.attributes[c.attribute];
									if (pro !== null && pro !== undefined){		//filter property
										if (c.value === pro) c._selected = true;
										if (c.group){
											c.group.forEach(g => {
												g._section = ch.name
												if (g.value === pro){
													c._selected = true;		//selected group
													g._selected = true;		//selected group item
												}
											})
										}
									}
									if (c.group){
										c.group.forEach(g => {
											g._section = ch.name
											g._valid = !g.warehouses || g.warehouses.includes(state.warehouse.id);
										})
										c._valid = c.group.filter(e => e._valid).length > 0;
									}
								})

								com._valid = com._valid && !!com.content.find(c => c._valid)
							}

							if (com.type === 'image-grid' || com.type === 'icon-grid'){
								com._hasToiletPaper = !!com.content?.find(e => e.label?.en.toLowerCase() === 'toilet paper')

								if (com.property === 'bundletype_id'){
									com._bundle._bundleType = com.content?.find(c => c._selected)
								}
							}
							break;

						case 'number':		//skip
						case 'textbox':		//skip
							///
							break;
	
						default:
							// slipsheets
							// case-summary
							// summery
							// gtin


							var pro = com.property? _node?.[com.property]: com.attribute? _node?.attributes[com.attribute] : null;

							if (com.attribute_id && p._settings.enabledAttributes){		//custom attribute
								com._valid = !!p._settings.enabledAttributes.find(a => a === com.attribute_id)
							}

							if (com.type === 'image-grid' || com.type === 'icon-grid'){
								com._hasToiletPaper = !!com.content?.find(e => e.label?.en.toLowerCase() === 'toilet paper')
							}

							if (com._valid && com.content){
								com.content = com.content.filter(c => !c.warehouses || c.warehouses.includes(state.warehouse.id))
								// com._valid = com.content.length > 0

								com.content.forEach(c => {
									c._section = ch.name
									c._valid = !c.warehouses || c.warehouses.includes(state.warehouse.id);
									if (!c._valid) return;

									if (c.attribute) pro = _node?.attributes[c.attribute];
									if (pro !== null && pro !== undefined){		//filter property
										if (c.value === pro) c._selected = true;
										if (c.group){
											c.group.forEach(g => {
												g._section = ch.name
												if (g.value === pro){
													c._selected = true;		//selected group
													g._selected = true;		//selected group item
												}
											})
										}
									}
									if (c.group){
										c.group.forEach(g => {
											g._section = ch.name
											g._valid = !g.warehouses || g.warehouses.includes(state.warehouse.id);
										})
										c._valid = c.group.filter(e => e._valid).length > 0;
									}
								})

								com._valid = com._valid && !!com.content.find(c => c._valid)
							}
						}
					})

					s._valid = s._valid && !!s.components.find(com => com._valid !== false)
				})

				p._valid = p._valid && !!p.sections.find(s => s._valid !== false)

				if (p._valid){
					ch._numPages ++;
					p._key = key ++;
					setup._pages.push(p);
				}
			})

			ch._valid = ch._numPages > 0;
			// ch._valid = true;	//test

			if (_node?.level === 'pack' || _node?.level === 'unit') _node._valid = ch._valid;

			setup._numPages += ch._numPages;
		})

		if (bundle.bundletype_id === 11){		//toiletpaper
			let pages = 0;
			setup._chapters.forEach(c => {
				if (c.name === 'pack' || c.name === 'unit') c._valid = false;
				pages += c._valid? c._numPages : 0;
			})
			setup._numPages = pages;
			setup._isToiletpaper = true;
		}else{
			setup._isToiletpaper = false;
		}

		// console.info('result pages:', setup._pages)

		/*
		// --- log out page structure:
		setup._chapters.forEach(ch => {
			console.log('c--', ch.name, ch._valid, ch)
			ch.pages?.forEach(p => {	//get target page from lookup
				console.log('\tp--', p.name, p._valid, p)
				// p.sections?.forEach(s => {
				// 	s.components?.forEach(c => {
				// 		console.info('\t\tcom---', c.type)
				// 	})
				// })
			})
		})
		*/

		console.info('teach-in setup:', setup);
	}


/*
	parseBundelNode = (s, _node, ch, p, state) => {
		s._bundle = _node			//set bundle reference
		s._valid = true				//section valid

		s.components.forEach(com => {
			com._section = ch.name
			com._bundle = _node	//set bundle reference
			com._valid = true

			switch (com.type){
			case 'multiscan':
				com.multiscans?.forEach(table => {
					let tid = table.warehouse_id + '.' + table.id
					if (!state.tables[tid]) state.tables[tid] = table	//new table found
				})

				com.additionalAttributes?.forEach(at => {
					at._valid = at.warehouses.includes(state.warehouse.id)
				})
				break;
			case 'photo-grid':
				com.content.forEach(c => {	//c.attribute = image_iso || image_front
					c._bundle = _node;
					let e = _node?.attributes[c.attribute];
					if (e){
						c._photo = (e.startsWith('data') || e.startsWith('http'))? e : state.config.api.uploads + e;
					}
				});
				break;
			case 'boolean':
				//if chapter = diverse than its a item-attribute
				if (ch.name === 'misc') com._bundle = _node.item
				break;
			case 'enum':
				//if chapter = diverse than its a item-attribute
				if (ch.name === 'misc') com._bundle = _node.item
				break;

			case 'stepper':
				var pro = com.property? _node?.[com.property]: com.attribute? _node?.attributes[com.attribute] : null;
				com.value = Number(pro);
				break;

			case 'image-grid':
			case 'icon-grid':
			case 'group':
				var pro = com.property? _node?.[com.property]: com.attribute? _node?.attributes[com.attribute] : null;

				if (com.attribute_id && p._settings.enabledAttributes){		//custom attribute
					com._valid = !!p._settings.enabledAttributes.find(a => a === com.attribute_id)
				}
				com._hasToiletPaper = !!com.content?.find(e => e.label?.en.toLowerCase() === 'toilet paper')

				if (com.attribute_id && p._settings.enabledAttributes){		//custom attribute
					com._valid = !!p._settings.enabledAttributes.find(a => a === com.attribute_id)
				}

				if (com.type === 'image-grid' || com.type === 'icon-grid'){
					com._hasToiletPaper = !!com.content?.find(e => e.label?.en.toLowerCase() === 'toilet paper')
				}

				if (com._valid && com.content){
					com.content = com.content.filter(c => !c.warehouses || c.warehouses.includes(state.warehouse.id))
					// com._valid = com.content.length > 0

					com.content.forEach(c => {
						c._section = ch.name
						c._valid = !c.warehouses || c.warehouses.includes(state.warehouse.id);
						if (!c._valid) return;

						if (c.attribute) pro = _node?.attributes[c.attribute];
						if (pro !== null && pro !== undefined){		//filter property
							if (c.value === pro) c._selected = true;
							if (c.group){
								c.group.forEach(g => {
									g._section = ch.name
									if (g.value === pro){
										c._selected = true;		//selected group
										g._selected = true;		//selected group item
									}
								})
							}
						}
						if (c.group){
							c.group.forEach(g => {
								g._section = ch.name
								g._valid = !g.warehouses || g.warehouses.includes(state.warehouse.id);
							})
							c._valid = c.group.filter(e => e._valid).length > 0;
						}
					})

					com._valid = com._valid && !!com.content.find(c => c._valid)
				}
				break;

			case 'number':		//skip
			case 'textbox':		//skip
				///
				break;

			default:
				// slipsheets
				// case-summary
				// summery
				// gtin


				var pro = com.property? _node?.[com.property]: com.attribute? _node?.attributes[com.attribute] : null;

				if (com.attribute_id && p._settings.enabledAttributes){		//custom attribute
					com._valid = !!p._settings.enabledAttributes.find(a => a === com.attribute_id)
				}

				if (com.type === 'image-grid' || com.type === 'icon-grid'){
					com._hasToiletPaper = !!com.content?.find(e => e.label?.en.toLowerCase() === 'toilet paper')
				}

				if (com._valid && com.content){
					com.content = com.content.filter(c => !c.warehouses || c.warehouses.includes(state.warehouse.id))
					// com._valid = com.content.length > 0

					com.content.forEach(c => {
						c._section = ch.name
						c._valid = !c.warehouses || c.warehouses.includes(state.warehouse.id);
						if (!c._valid) return;

						if (c.attribute) pro = _node?.attributes[c.attribute];
						if (pro !== null && pro !== undefined){		//filter property
							if (c.value === pro) c._selected = true;
							if (c.group){
								c.group.forEach(g => {
									g._section = ch.name
									if (g.value === pro){
										c._selected = true;		//selected group
										g._selected = true;		//selected group item
									}
								})
							}
						}
						if (c.group){
							c.group.forEach(g => {
								g._section = ch.name
								g._valid = !g.warehouses || g.warehouses.includes(state.warehouse.id);
							})
							c._valid = c.group.filter(e => e._valid).length > 0;
						}
					})

					com._valid = com._valid && !!com.content.find(c => c._valid)
				}
			}
		})

		s._valid = s._valid && !!s.components.find(com => com._valid !== false)
	}
*/


	// ------------------------------------------------------------------------ cacheBundle
	cacheBundle = async bundle => {
		let storeData = await this.cache.getItem('bundles-store') || {};
		console.log('---cache store data locally to bundles-store:', bundle);

		storeData[bundle.id] = bundle;
		await this.cache.setItem('bundles-store', storeData);
	}


	// ------------------------------------------------------------------------ replaceBundle
	replaceBundle = (sourceBundles, bundle, addIfMissing=false) => {
		if (!sourceBundles || !bundle) return
		
		let idx = sourceBundles.findIndex(e => e.id === bundle.id);
		if (idx > -1){
			sourceBundles[idx] = bundle		//replace existing bundle

		}else if (addIfMissing){
			sourceBundles.push(bundle)		//add as new bundle
		}
	}

	
	// ------------------------------------------------------------------------ createBundle
	// create new bundle on backend
	// from parseAndSaveResult
	createBundle = async bundle => {
		if (!bundle) return

		bundle.id = null;
		let child = bundle.child;
		while(child){				//reset CASE-, PACK-, UNIT-ids
			child.id = null;
			child = child.child;
		}

		let url = this.config.api.url + 'bundles'
		console.log('---create new bundle:', url, bundle, '...')
	
		let result = await this.fetch(url, {		//create bundle
			method : 'POST',
			body	: JSON.stringify(bundle),
		})

		return result
	}


	// ------------------------------------------------------------------------ updateBundle
	// update existing bundle on backend
	// from syncBundle or parseAndSaveResult
	updateBundle = async bundle => {
		if (!bundle?.id) return

		let url = this.config.api.url + 'bundles/' + bundle.id;
		console.log('---update existing bundle:', url, bundle, '...');
	
		let result = await this.fetch(url, {		//update bundle
			method : 'PUT',
			body	: JSON.stringify(bundle),
		})

		console.log('---result:', result)

		return result
	}


	// ------------------------------------------------------------------------ uploadBundleImages
	uploadBundleImages = async node => {
		if (!node) return

		if (node.attributes){
			for(let a in node.attributes){
				if (a.startsWith('image_') && node.attributes[a].startsWith('data')){

					let len = node.attributes[a].length
					let end = node.attributes[a].substring(len-10)

					console.log('upload image:', node.id, a, '..'+end, '...')
					let data = await this.uploadImage(node.attributes[a])	//return: {filename:'', url:''}

					if (data) node.attributes[a] = data.url
					else return false	//stup uploading images
				}
			}

			if (node.child) await this.uploadBundleImages(node.child)
		}
		return true
	}


	//------------------------------------------------------------------------- uploadImage
	// source = dataUrl or blob
	uploadImage = async (source) => {
		if (!source) return null

		let blob = (typeof source === 'string' && source?.startsWith('data:'))?
			await (await fetch(source)).blob()		//convert dataUrl to blob
			: source.size? source : null

		if (!blob) return null

		let formData = new FormData();
		formData.append('file', blob, 'image.jpg');		//'image.png'

		let options = {
			method: 'POST',
			body: formData,
			// headers: {'Content-Type': 'multipart/form-data'},
			headers: {
				Accept: 'application/json',
				// 'Content-Type': 'multipart/form-data',	//Content-Type is create automatically
				// 'content-type'	: 'application/json; charset=utf-8',
				'Authorization': 'Bearer ' + (store.user._token || '')
			},
		};

		let url = this.config.api.url + 'upload'
		console.log('---upload image:', url, options, '...');

		let data = await Sys.fetch(url, options);
		// data = await store.fetch(url, options);

		if (data){
			console.log('upload success:', data.url);
			return data;
		}

		console.error('upload error')
		// state.photoItem._bundle.attributes[state.photoItem.attribute] = data.filename;

		return null;
	}


	// ------------------------------------------------------------------------ startOnlineCheck
	startOnlineCheck(){
		let interval = this.config.onlineCheck?.interval || 10000
		// console.log('---start onlineCheck', interval)
		clearInterval(this._onlineTimer)
		this._onlineTimer = setInterval(this.checkOnlineState.bind(this), interval)
		this.checkOnlineState()
	}


	// ------------------------------------------------------------------------ checkOnlineState
	async checkOnlineState(){
		let res = await fetch(this.config.api.url + 'version', {method:'HEAD'}).catch(err => null)
		let isOnline = !!res?.ok

		if (isOnline !== this.get().isOnline){
			// console.log('---online state changed to', isOnline)
			this.set({isOnline})
			this.action?.('online', isOnline)
		}
	}


	// ------------------------------------------------------------------------ stopOnlineCheck
	stopOnlineCheck(){
		console.log('---stop onlineCheck')
		clearInterval(this._onlineTimer)
	}

	
	// ------------------------------------------------------------------------ clearSiteData
	async clearSiteData(){
		console.log('clear site data!', caches, global.serviceWorker, window.indexedDB, '...')

		await this.cache.clear()

		localStorage.clear()
		sessionStorage.clear()		//skip this for keeping cached login data

		let dbs = await window.indexedDB?.databases()
		dbs?.forEach(async db => {
			console.log('delete indexDb ' + db.name, '...')
			window.indexedDB.deleteDatabase(db.name)
		})

		const keys = await caches.keys();
		keys.map(async (cache) => {
			if(cache !== 'v2') {
				console.log('Service Worker: Removing old cache: ' + cache);
				return await caches.delete(cache);
			}
		})

		global.serviceWorker?.unregister();		//clear cache and reload

		console.log('OK')

		setTimeout(() => {
			// alert('click OK to relaod now!')
			window.location.reload(true); 

		}, 1000)
	}


	// ------------------------------------------------------------------------ createScan
	// if no new canvas, the scan is a copy of an existing product
	createScan = (state, origin) => {
		let scan = {
			_id			: state.scanLog.length,
			user_id		: state.user.id || state.user.mandate_id,
			bundle_id	: state.bundle?.id,
			started_at	: Sys.getTimeString(),	//e.g. 2020-11-15 10:23:45
			// started_at	: Date.now(),	//e.g. 2020-11-15 10:23:45
			closed_at	: '',
			origin,		//	: 'scan',	//scan, search
			result		: 'completed',	//cancelled, completed, updated
			data		: '[]',
			image		: null,			//image-url from current scan canvas after image-upload
			_state		: 'new',
		}

		console.log('create scan:', scan);
		// the new scan will added to the state.scanLog only on sendScan
		// state.scan will removed at teach-in-close
		state.scan = scan;
	}


	// ------------------------------------------------------------------------ parseAndSaveResult
	parseAndSaveResult = async state => {
		let bundle = state.bundle;
		if (!bundle) return

		bundle._search = this.createSearchString(bundle)	//update search string
		this.replaceBundle(state.bundles, bundle)			//replace the original bundle with the new generated

		let result
		if (await this.uploadBundleImages(bundle)){		//if success
			result = bundle._clone? await this.createBundle(bundle) : await this.updateBundle(bundle)

			if (result){		//sent successfully
				result._search = this.createSearchString(result)
				bundle.id = result.id;							//set new bundle.id if created new
				this.copyAttributeImages(bundle, result)		//copy all existing attribute images
				this.replaceBundle(state.bundles, result, bundle._clone)

			}else{
				console.error('error on saving bundle!');
				await this.cacheBundle(bundle)
			}
		}else{		//error on upload bundle images
			await this.cacheBundle(bundle)
		}

		await this.saveScan(state);					//save or cache the current scan if exists

		await this.updateWarehouseBundlesCache(state)		//update the current cached bundles

		state.action('teach-in-saved', result? 1 : 2);		//saved or cached state
	}

	
	// ------------------------------------------------------------------------ saveScan
	saveScan = async (state) => {
		if (!state.scan) return;

		let scan = state.scan;
		console.log('---save scan', scan, '...')

		scan.bundle_id = state.bundle?.id		//update or set final bundle.id
		scan.closed_at = Sys.getTimeString();	//e.g.: 2020-11-15 10:23:45
		// scan.closed_at = Date.now();	//e.g.: 2020-11-15 10:23:45
		// console.log('save scan:', scan, state.canvas);

		if (state.canvas){		//presetted product scan exists
			// console.log('... upload canvas from gtin');
			state.canvas.toBlob(async blob => {
				// let data = await uploadBlob(blob, state, 'scan');
				let data = await store.uploadImage(blob);
				console.log('---upload complete!', data)

				if (!data){
					console.log('---cache scan image!')
					// let id = 'scan.' + pi.attribute + '.' + pi._bundle.id
					// console.log('---cache data:', id, pi);
					// store.mediaCache.setItem(id, pi)
				}
				
				// scan._image = URL.createObjectURL(blob);	//create only objectUrl for offline use
				scan._image = state.canvas.toDataURL('image/jpeg', 0.9)
				await this.sendScan(state);

			}, 'image/jpeg', 0.9);		//, 'image/jpeg', 0.9);

		}else{		//new scan from duplicated product
			// console.log('no canvas from gtin image exists!')
			await this.sendScan(state);
		}
	}


	// ------------------------------------------------------------------------ sendScan
	sendScan = async (state) => {
		let url = state.config.api.url + 'scans';
		console.log('send scan to:', url, '...');

		let result;
		result = await store.fetch(url, {
			method	: 'POST',
			body	: JSON.stringify(state.scan),
		})

		let bundle = state.bundle;
		state.scan._name = bundle.name;

		if (!result){		//error on saving scan or offline
			// console.log('OFFLINE!');
			state.scan._state = 'cached';	//cache this scan

		}else{		//successfully sended
			// console.log('scan sended successfully!', result);
			state.scan._state = 'sent';		//scan sent ok
		}

		if (!state.scan._image){
			if (bundle.attributes.image_iso){
				state.scan._image = bundle.attributes.image_iso
			}else if (bundle.attributes.image_front){
				state.scan._image = bundle.attributes.image_front
			}
		}

		state.action('scanLog', [...state.scanLog, state.scan])		//append scan to scan-log
	}


	// ------------------------------------------------------------------------ getIsoImage
	getBundleImage = async (bundle) => {
		// image_iso

	}
	

	//------------------------------------------------------------------------- checkSync
	// check if some sync processes are not sent
	// bundles-store, photo-attribute-id, scan-id, scan-log
	checkSync = async state => {
		console.log('---check SyncLog:', state.scanLog);

		let storeData = await store.cache.getItem('bundles-store');
		// console.log('bundles-store:', storeData);

		if (storeData){		//bundles found to send
			for (let i in storeData){
				let bundle = storeData[i];
				let saved = await this.syncBundle(state, bundle);	//sync and replace bundle

				if (saved){		//success
					// console.log('ok');
					delete storeData[i];	//remove item from store-data
					// await localForage.setItem('bundles-store', storeData);		//update storeData
				}
			}

			// update store data
			// console.log('update store-data:', storeData);
			await store.cache.setItem('bundles-store', storeData);		//update storeData
		}


		if (state.scanLog.length){
			// console.log('---check scans to upload ...');

			let url = state.config.api.url + 'scans';
			for (let i in state.scanLog){
				let scan = state.scanLog[i];
				if (scan._state !== 'sent'){
					// console.log('> send scan:', scan, '...');
				
					let result = await store.fetch(url, {
						method	: 'POST',
						body	: JSON.stringify(scan),
						// headers	: {'content-type' : 'application/json; charset=utf-8'}
					})

					if (result){
						// console.log('ok', result);
						scan._state = 'sent';
					}
				}
			}
		
			// update scan-log
			// console.log('---update scanLog ...');
			// let scanLog = state.scanLog.filter(e => e._state !== 'sent');

			// await store.cache.setItem('scan-log', state.scanLog);	//done in the provider scanLog dispatch
			state.action('scanLog', state.scanLog);		//update scanlog
			// console.log('ok');
		}
	}


	//------------------------------------------------------------------------- syncBundle
	syncBundle = async (state, bundle) => {
		console.log('sync bundle', bundle, '...')

		if (await store.uploadBundleImages(bundle)){	//if success
			let result = bundle._clone? await store.createBundle(bundle) : await store.updateBundle(bundle)

			if (result){		//sent successfully
				result._search = store.createSearchString(result)
				store.copyAttributeImages(bundle, result)		//copy all existing attribute images
		
				store.replaceBundle(state.bundles, result, bundle._clone)
				return true

				// saveScan(state);					//save or cache the current scan if exists
				// state.action('teach-in-saved', 1);	//saved

			}else{
				console.error('error on saving bundle!');
				return false

				// saveScan(state);					//save or cache the current scan if exists
				// state.action('teach-in-saved', 2);	//cached
			}

		}else{
			return false
		}
	}


/*
// ------------------------------------------------------------------------ onLogTest
async onLogTest(){
	if (!this._testCount) this._testCount = 20
	this._testCount --

	if (!this.scanCache){
		this.scanCache = localforage.createInstance({
			name: this.config.name,
			storeName: 'scan-cache'
		})
		this.lastScanCache = await this.scanCache.getItem('_last') || 10000
		// this.lastScanCache = 10000

	}
	this.lastScanCache ++

	let data = await this.fetch('https://knapp.jumptoday.group/bl/public/api/scans/' + this.lastScanCache)
	if (!data?.bundle_id){
		console.log('complete!')
		return
	}

	console.log(this.lastScanCache, data.bundle_id, data.bundle.name)
	if (data.bundle_id === 861605){
		console.error('!!!!!!!!!!!!!!!!!---bundle found!', data)
	}
	await this.scanCache.setItem(this.lastScanCache, data)
	await this.scanCache.setItem('_last', this.lastScanCache)

	if (this._testCount > 0) this.onLogTest()
}
*/

}


let store = new Store()
export default store
